export default "__VITE_ASSET__C30$Hyw0__"